import axios from 'axios';

import { EditAppointmentType } from './types';

import {
  CREATE_APPOINTMENT,
  CONNECT_APPOINTMENTS,
  END_APPOINTMENTS,
  UPDATE_ROUTE_START
} from 'RestAPIs/endpoints';

export interface ConnectAppointmentGroupingPayload {
  appointmentGroupingStart: string;
  appointmentGroupingId: string;
  editAppointmentType: EditAppointmentType;
  suppressWarnings: boolean;
  correlationToken?: string;
}

export interface UpdateRouteStartPayload
  extends ConnectAppointmentGroupingPayload {
  start: string;
}

export interface EndAppointmentsPayload {
  date: string;
  appointmentIds: string[];
}

export interface CommandResult {
  success: boolean;
  notifications: Notification[];
}

export const connectAppointmentGrouping = (
  payload: ConnectAppointmentGroupingPayload
) =>
  axios.put<ConnectAppointmentGroupingPayload, CommandResult>(
    CONNECT_APPOINTMENTS,
    payload,
    {
      pathParams: { appointmentGroupingId: payload.appointmentGroupingId }
    }
  );

export const updateRouteStart = ({
  originalAppointmentGroupingStart,
  appointmentGroupingId,
  editAppointmentType,
  suppressWarnings,
  start
}) =>
  axios.put<UpdateRouteStartPayload, CommandResult>(
    UPDATE_ROUTE_START,
    {
      originalAppointmentGroupingStart,
      editAppointmentType,
      suppressWarnings,
      start
    },
    {
      pathParams: { appointmentGroupingId }
    }
  );

export const endAppointments = ({ date, appointmentIds }) =>
  axios.put<EndAppointmentsPayload>(END_APPOINTMENTS, {
    date,
    appointmentIds
  });

type DayInWeek =
  | 'SUNDAY'
  | 'MONDAY'
  | 'TUESDAY'
  | 'WEDNESDAY'
  | 'THURSDAY'
  | 'FRIDAY'
  | 'SATURDAY';

export interface CreateAppointmentPayload {
  start: Date;
  durationInSeconds: number;
  activityEntityId: string;
  organizationalUnitId: number;
  description?: string;
  recurrenceRule?: {
    periodType: string;
    interval: number;
    dayOfMonth?: number;
    dayInWeekSet: DayInWeek[];
    setPosition?: number;
    recurrenceRange: {
      type: 'NO_END' | 'END_ON_DATE' | 'END_ON_OCCURRENCE';
      end: Date;
      numberOfOccurrences?: number;
    };
  };
}

export const createAppointment = ({
  start,
  durationInSeconds,
  activityEntityId,
  organizationalUnitId,
  description,
  recurrenceRule
}) =>
  axios.post<CreateAppointmentPayload>(CREATE_APPOINTMENT, {
    start,
    durationInSeconds,
    activityEntityId,
    organizationalUnitId,
    description,
    recurrenceRule
  });
